export default {
  projectName: 'SwissTrax'
};
